/* 🔗 FUSION RIBBON engine (Captain P0, 10-15). Rides beside assets/ias-shiny.js (which still owns the ladder paint, the ship
   math and the one-tap Add). This file adds the orchestration:
   ① chord-builder carousel — arrows, colour switch (honest dual-supply re-pick), chips: "Completes D Major" (harmony map
     chords) · "Unlocks 15% off" (rates tiers × live key count, window-honest) · harmony "why" lines (map partners);
   ② rewards — confetti + toast when the cart climbs a ladder tier or crosses free shipping; "Added ✓" toast on every Add;
   ③ tooltips — badges and piano keys explain themselves (hover, focus or tap);
   ④ Z-INDEX LAW sentinel — cart + checkout outrank everything. Any floater (Klaviyo teaser/popup, Shopify chat bubble,
     Google badge, Gorgias) that would cover Add to cart / Check out is lifted clear or set behind; an auto-opened Klaviyo
     popup that would sit over a visible buy button is closed (its teaser stays, so the offer is one tap away).
   Reads assets/ias-rates.json + assets/ias-harmony-map.json only; never hand-types a % or a pairing. Fails closed. */
(function () {
  'use strict';
  if (window.__iasFusion) return;
  window.__iasFusion = 1;

  var me = document.currentScript;
  var RATES = me && me.dataset.rates, MAP = me && me.dataset.map;
  var rates = null, hmap = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getJSON(u) { return u ? fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null); }
  function block() { return rates ? (rates[rates.mode] || {}) : {}; }
  function inWindow() {
    if (!rates || rates.mode === 'off') return false;
    if (rates.mode !== 'event') return true;
    if (/[?&]ias-ladder-preview=1/.test(location.search)) return true;
    var w = rates.window || {}, n = Date.now();
    return !(w.starts_at && n < Date.parse(w.starts_at)) && !(w.ends_at && n > Date.parse(w.ends_at));
  }
  function tiers() { return inWindow() ? (block().tiers || []) : []; }
  function tierFor(k) { var t = null; tiers().forEach(function (x) { if (k >= x.min_keys) t = x; }); return t; }

  /* ───────── ① CAROUSEL ───────── */
  function scope(el) { return el.closest('cart-drawer, #MainContent, main') || document; }
  function liveKeys(el) { var l = scope(el).querySelector('[data-shy-ladder]'); return l ? (+l.dataset.keys || 0) : 0; }
  function cartHandles(el) {
    var s = scope(el), out = [];
    s.querySelectorAll('.cart-item__name[href], .cart-item a[href*="/products/"]').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (m && out.indexOf(m[1]) < 0) out.push(m[1]);
    });
    return out;
  }
  function noteOf(title) { return String(title || '').split(' ')[0]; }

  function chipCards(fx) {
    var keys = liveKeys(fx), inCart = cartHandles(fx);
    var attrs = (hmap && hmap.attrs) || {}, partners = (hmap && hmap.partners) || {}, chords = (hmap && hmap.chords) || {};
    var cards = [].slice.call(fx.querySelectorAll('[data-fx-card]'));
    cards.forEach(function (c) {
      var h = c.dataset.handle, chip = c.querySelector('[data-fx-chip]'), why = c.querySelector('[data-fx-why]');
      var text = '', rank = 2;
      /* chord completion — the harmony engine: this card + the cart's notes form a TRUE chord the cart isn't already */
      var H = window.IASHarmony, items = cartItems(fx);
      if (H && items.length) {
        var before = H.classify(items.map(function (i) { return H.voice(i, attrs); }).filter(Boolean));
        var withIt = H.classify(items.concat([{ handle: h, title: c.dataset.title }]).map(function (i) { return H.voice(i, attrs); }).filter(Boolean));
        if (withIt.trueChord && !before.trueChord) { text = 'Completes ' + H.chordName(withIt.root, withIt.quality); rank = 0; }
      }
      /* ladder tier unlock — only for keys the native discount counts, only inside the rates window */
      if (!text && c.dataset.eligible === '1') {
        var now = tierFor(keys), next = tierFor(keys + 1);
        /* ONE-DISCOUNT TRUTH (10-21): a tier only "unlocks" if the ladder really wins after this add — a bag on the pack pairing
           can stay on the pairing (Shopify applies ONE automatic discount, the best one) */
        var qc = window.IASPack && IASPack.quote && IASPack.cart() ? IASPack.quote([{ cents: cardPrice(c), key: true, handle: h }], IASPack.cart()) : null;
        if (next && (!now || next.pct > now.pct) && (!qc || qc.win === 'ladder')) { text = 'Unlocks ' + next.pct + '% off'; rank = 1; }
      }
      chip.textContent = text; chip.hidden = !text;
      /* harmony why-line — the map's partner list for a cart key names this offer */
      if (c.dataset.kind === 'build' && why && !why.dataset.fxSet) {
        inCart.some(function (ch) {
          var a = attrs[ch]; if (!a) return false;
          var list = partners[a.key + '|' + a.hz] || [];
          if (list.indexOf(h) >= 0) {
            var t = (hmap.products && hmap.products[ch] && hmap.products[ch].t) || '';
            why.textContent = 'Harmonizes with your ' + (noteOf(t) || a.key.toUpperCase());
            rank -= 0.5;
            return true;
          }
          return false;
        });
        if (hmap) why.dataset.fxSet = '1';
      }
      c.dataset.fxRank = c.dataset.kind === 'pair' ? -1 : rank;
    });
    /* stable re-rank: pairings first (Deck canon), then chord-completers, tier-unlockers, harmony partners, the rest */
    fx.querySelectorAll('[data-fx-track]:not([data-fx-strack])').forEach(function (track) {   /* the smart row keeps its own priority order */
      var own = [].slice.call(track.querySelectorAll('[data-fx-card]'));
      var sorted = own.slice().sort(function (a, b) { return (+a.dataset.fxRank) - (+b.dataset.fxRank) || own.indexOf(a) - own.indexOf(b); });
      if (sorted.some(function (c, i) { return c !== own[i]; })) sorted.forEach(function (c) { track.appendChild(c); });
    });
  }

  /* ───────── 🎼 HARMONY PANEL (DIAL-IN 10-16) — one target chord, real pitch, honest cards ───────── */
  function cartItems(el) {
    var out = [];
    scope(el).querySelectorAll('.cart-item').forEach(function (row) {
      var a = row.querySelector('.cart-item__name'); if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!m) return;
      var q = +((row.querySelector('input[name="updates[]"], .quantity__input') || {}).value || 1);
      var colour = ''; row.querySelectorAll('.product-option').forEach(function (o) { var dt = o.querySelector('dt'), dd = o.querySelector('dd'); if (dt && dd && /colou?r/i.test(dt.textContent)) colour = dd.textContent.replace(/[,\s]+$/, '').trim(); });   // Dawn prints "Army Blue," (list comma)
      for (var i = 0; i < Math.min(q, 6); i++) out.push({ handle: m[1], title: a.textContent.trim(), colour: colour });
    });
    return out;
  }
  var catP = null;
  function catalog() {
    if (catP) return catP;
    var inl = null; try { inl = JSON.parse((document.querySelector('[data-ias-cat]') || {}).textContent || 'null'); } catch (e) {}
    if (inl && inl.length) return (catP = Promise.resolve(inl));
    try { var c = JSON.parse(sessionStorage.getItem('fx-cat') || 'null'); if (c && Date.now() - c.t < 6e5) return (catP = Promise.resolve(c.d)); } catch (e) {}
    catP = getJSON('/collections/ladder-eligible/products.json?limit=250').then(function (j) {
      var d = ((j && j.products) || []).map(function (p) { return { handle: p.handle, title: p.title, available: p.variants.some(function (v) { return v.available; }) }; });
      try { sessionStorage.setItem('fx-cat', JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
    return catP;
  }
  var cardCache = {};
  function cardFor(handle) {
    if (!cardCache[handle]) cardCache[handle] = fetch('/products/' + handle + '?section_id=ias-fx-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var li = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fx-card]'); return li ? li.outerHTML : '';
      }).catch(function () { return ''; });
    return cardCache[handle];
  }
  var ROLE = { root: 'Root', third: 'Third', fifth: 'Fifth', second: '2nd', fourth: '4th' };
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* DECK ③ AFFORDABILITY FIRST (10-17): every drawer upsell card leads with its price + what it saves, the reason second —
     "$50 · Trio saves you $30 · completes F♯ minor". The save is Shopify-true (IASSetPrice: line totals + the rates tier, repricing
     the keys already in the bag), shown only when > 0, never rounded. Re-runs when the card's colour (and price) changes. */
  var cartRawP = null;
  function cartRaw() { return cartRawP || (cartRawP = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })); }
  function eligibleSet() { var s = {}; try { (JSON.parse((document.querySelector('[data-ias-cat]') || {}).textContent || '[]') || []).forEach(function (p) { s[p.handle] = 1; }); } catch (e) {} return s; }
  function money2(x) { return '$' + (x % 100 ? (x / 100).toFixed(2) : String(x / 100)); }
  function afford(li, reason) {
    var why = li && li.querySelector('[data-fx-why]'); if (!why) return;
    if (reason != null) why.dataset.fxReason = reason;
    reason = why.dataset.fxReason; if (!reason) return;
    var cents = cardPrice(li), card = li.matches('[data-fx-card]') ? li : li.querySelector('[data-fx-card]'), handle = card && card.dataset.handle;
    var low = reason.charAt(0).toLowerCase() + reason.slice(1);
    if (!cents) { why.textContent = reason; return; }
    why.textContent = money2(cents) + ' · ' + low;
    Promise.all([cartRaw(), window.IASPack && IASPack.load ? IASPack.load() : null]).then(function (rr) {   /* pack config first: IASSetPrice models the one-discount rule with it */
      var c = rr[0], el = eligibleSet(), key = !!el[handle], tz = tiers(), sp = window.IASSetPrice && c ? IASSetPrice(c, [{ cents: cents, key: key, handle: handle }], tz) : null;
      var k = 0; ((c && c.items) || []).forEach(function (i) { if (el[i.handle]) k += i.quantity; });
      var t = key ? tierFor(k + 1) : null, nm = t ? String(t.name || '').split(' ')[0] : '';
      if (why.dataset.fxReason !== reason || cardPrice(li) !== cents) return;                  // a newer colour/price won
      why.textContent = money2(cents) + (sp && sp.save > 0 && nm ? ' · ' + nm + ' saves you ' + money2(sp.save) : '') + ' · ' + low;
      /* KOSH P2 (10-21): an expansion pack offered next to its matching F#4 shows what the cart will really charge — struck list, paired price
         (IASPack = the one pairing rule; ONE-DISCOUNT TRUTH 10-21: full price when the bag's key ladder already wins). The card's own price node keeps the list price, so a colour switch never double-discounts. */
      if (window.IASPack && IASPack.load) IASPack.load().then(function () {
        if (why.dataset.fxReason !== reason || cardPrice(li) !== cents) return;
        var st = IASPack.state(handle, c), pe = li.querySelector('[data-fx-price]'), now = IASPack.now(handle, cents, c), tag = li.querySelector('.fx-pack-now');
        if (!pe || !st) return;
        if (now < cents) {
          if (!tag) { tag = document.createElement('b'); tag.className = 'fx-pack-now'; pe.parentNode.insertBefore(tag, pe); }
          tag.textContent = '$' + (now / 100).toFixed(2) + ' '; pe.style.textDecoration = 'line-through'; pe.style.fontWeight = '500'; pe.style.color = '#6E6E6E';
          why.textContent = money2(now) + ' · ' + low;
        } else {
          if (tag) { tag.remove(); pe.style.textDecoration = ''; pe.style.fontWeight = ''; pe.style.color = ''; }
          /* ONE-DISCOUNT TRUTH (10-21): no pairing in this bag (the key ladder wins) → no "20% off with your F#4" promise on the card */
          var qq = st.fluteQty > 0 && IASPack.quote ? IASPack.quote([{ cents: cents, key: false, handle: handle }], c) : null;
          if (st.fluteQty > 0) why.textContent = money2(cents) + ' · ' + low.replace(/\s*·\s*\d+% off with your F#4/, '') + (qq && qq.after.lp && qq.after.lad >= qq.after.pr ? ' · your key discount already saves more' : '');
        }
      });
    });
  }
  function harmony(part) {
    cartRawP = null;
    var H = window.IASHarmony; if (!H || !hmap) return;
    var items = cartItems(part), sig = items.map(function (i) { return i.handle; }).join('|');
    if (part.dataset.fxSig === sig) return;
    part.dataset.fxSig = sig;
    catalog().then(function (cat) {
      if (part.dataset.fxSig !== sig) return;
      var r = H.suggest(items, cat, hmap.attrs || {}), c = r.classify, box = part.querySelector('[data-fx-h]'), track = part.querySelector('[data-fx-htrack]');
      if (r.state === 'empty' || (!r.target && !r.warn)) { part.hidden = true; smart(part, r, cat, sig); return; }
      /* the shopper's mood choice: swap the third (minor ↔ major) — still ONE target chord, re-rendered whole */
      /* KOSH-FIX ③ CHORD MEMORY: the shopper's own Major/Minor for this root wins (set on the PDP or here) — the chord never flips on its own */
      var mood = window.IASMood && r.target ? IASMood.get(r.target.root) : null;
      if (r.alt && mood && r.alt.quality === mood && r.target.quality !== mood) {
        var oldThird = (r.need || []).filter(function (n) { return n.role === 'third'; })[0];
        var was = { name: r.target.name, quality: r.target.quality };
        r.target = { name: r.alt.name, quality: r.alt.quality, root: r.target.root, trueChord: true };
        r.need = r.need.map(function (n) { return n.role === 'third' ? r.alt.swap : n; });
        r.alt = { name: was.name, quality: was.quality, swap: oldThird };
      }
      var tri = r.target ? [0, 1, 2] : [];
      var roles = r.target ? (r.have || []).map(function (h) { return h.role; }) : [];
      var chips = '';
      if (r.target) {
        var tones = ['root', r.target.quality === 'sus4' ? 'fourth' : r.target.quality === 'sus2' ? 'second' : 'third', 'fifth'];
        var need = (r.need || []).reduce(function (m, n) { m[n.role] = n; return m; }, {});
        var nextRole = r.state !== 'complete' && (r.need || [])[0] ? r.need[0].role : null;      // RESTRAINT: thin ring on the next chip
        chips = '<div class="fx-h__roles" role="list" aria-label="' + esc(r.target.name) + '">' + tones.map(function (t) {
          var n = need[t], on = r.state === 'complete' || !n;
          return '<span role="listitem" class="fx-h__role' + (on ? ' is-on' : '') + (t === nextRole ? ' is-next' : '') + '" data-fx-tip="' + esc(H.LESSON[t === 'root' ? 'root' : t === 'fifth' ? 'fifth' : 'third'] || '') + '" tabindex="0"><b>' + ROLE[t] + '</b>' +
            (n ? esc(n.note) : '✓') + '</span>';
        }).join('') + '</div>';
      }
      var aim = '';
      /* RESTRAINT copy: short, human — one sentence, one optional quiet link */
      if (r.state === 'complete') aim = 'That’s a chord — every note has its job.';
      else if (r.state === 'build' || r.state === 'clash') aim = '<b>' + esc(r.target.name) + '</b> — add ' +
        r.need.map(function (n) { return '<b>' + esc(n.note) + '</b>'; }).join(' and ') + '.' +
        (r.clash ? ' <span class="fx-h__out">' + esc(r.clash.join(', ')) + (r.clash.length > 1 ? ' sit' : ' sits') + ' outside it.</span>' : '') +
        (r.alt ? ' <button type="button" class="fx-h__alt" data-fx-alt>' + (r.alt.quality === 'major' ? 'Brighter: ' : 'Softer: ') + esc(r.alt.name) + '</button>' : '');
      var warn = r.warn === 'hz' ? '<p class="fx-h__warn" role="note">⚠️ Heads up: 432 and 440 won\'t sit in tune together. Chords below follow your ' + esc(r.hz) + ' Hz keys.</p>'
        : r.warn === 'scale' ? '<p class="fx-h__warn" role="note">⚠️ ' + esc(H.LESSON.scale) + '</p>' : '';
      box.innerHTML = chips + '<p class="fx-h__now">' + esc(c.label || '') + ' <button type="button" class="fx-h__i" data-fx-tip="' + esc(c.lesson || H.LESSON.triad) + '" aria-label="What does this mean?">i</button></p>' +
        (aim ? '<p class="fx-h__aim">' + aim + '</p>' : '') + warn;
      part.hidden = false;
      track.innerHTML = '';
      if (r.state !== 'build' && r.state !== 'clash') { track.hidden = true; smart(part, r, cat, sig); return; }
      track.hidden = false;
      var lead = (scope(part).querySelector('.cart-item dl .product-option dd, .cart-item .product-option dd') || {}).textContent;
      function place(n, slot) {
        return cardFor(n.pick.handle).then(function (html) {
          if (!html || part.dataset.fxSig !== sig) return;
          var tmp = document.createElement('ul'); tmp.innerHTML = html; var li = tmp.firstElementChild;
          li.dataset.fxRole = n.role;
          var why = li.querySelector('[data-fx-why]'); if (why) { why.dataset.fxSet = '1'; afford(li, (r.need || []).length === 1 ? 'Completes ' + (slot || r.target.name) : 'The ' + n.role + ' of ' + (slot || r.target.name)); }
          var sel = li.querySelector('[data-fx-colour]');
          var old = track.querySelector('[data-fx-role="' + n.role + '"]'); if (old) old.replaceWith(li); else track.appendChild(li);
          var ORD = { root: 0, second: 1, third: 1, fourth: 1, fifth: 2 };
          [].slice.call(track.children).sort(function (a, b) { return ORD[a.dataset.fxRole] - ORD[b.dataset.fxRole]; }).forEach(function (x) { track.appendChild(x); });
          if (sel && lead && [].some.call(sel.options, function (o) { return o.value === lead.trim(); })) { sel.value = lead.trim(); sel.dispatchEvent(new Event('change', { bubbles: false })); }
          hideDupes(part);
          /* ROUND 3 FIX (10-20): chip the card now — the page observer ignores changes inside tracks, so a late card waited for an unrelated change */
          var fxe = part.closest('[data-fx]'); if (fxe && (hmap || rates)) setTimeout(function () { chipCards(fxe); }, 0);
        });
      }
      Promise.all(r.need.map(function (n) { return place(n); })).then(function () { smart(part, r, cat, sig); });
      var altBtn = box.querySelector('[data-fx-alt]');
      if (altBtn) altBtn.onclick = function () { if (window.IASMood && r.target && r.alt) IASMood.set(r.target.root, r.alt.quality); part.dataset.fxSig = ''; harmony(part); };
    });
  }
  /* ───────── 🥕 SMART ROW (FINAL INFUSION 10-16) — "You may also like" becomes ONE engine row, max 3 ─────────
     order (POLISH 10-16): the matching V2 Expansion Pack FIRST when a V2 flute is in the cart without it → ② GAP-FILLER (only when the next-best-step pick does not cross the free-ship line: the cheapest key WITH Ships Now
     stock whose add is guaranteed to cross — lower-bound math, same as the ladder) → ① chord-completing key (a pick, or another
     form of a missing tone) → the matching V2 Expansion Pack when a V2 flute is in the cart → a little extra (D5 Pocket 2.0 ·
     G3 / D4 Ocarina) only with Ships Now stock. Never the cart, never the chord row, never twice. Empty → no row.
     ③ shelf-first: each card switches to a colour with Ships Now stock when its default pick has none. KPI: drawer-smart / gap-fill. */
  function cardPrice(li) { var pr = li.querySelector('[data-fx-price]'); return Math.round(parseFloat(((pr && pr.textContent) || '0').replace(/[^0-9.]/g, '')) * 100) || 0; }
  function shipMath(part) {
    var lad = scope(part).querySelector('[data-shy-ladder]'), T = Math.round(((rates && rates.free_ship_threshold) || 0) * 100);
    if (!lad || !T || (lad.dataset.currency || 'USD') !== 'USD') return null;
    var keys = +lad.dataset.keys || 0, total = +lad.dataset.total || 0, orig = +lad.dataset.original || 0;
    var t0 = tierFor(keys), t1 = tierFor(keys + 1), nonTier = Math.max(0, (orig - total) - Math.round(orig * (t0 ? t0.pct : 0) / 100));
    return { T: T, total: total, proj: function (p) { return Math.floor((orig + p) * (100 - (t1 ? t1.pct : 0)) / 100) - nonTier; } };
  }
  function packColour(li, colour) {
    var sel = li.querySelector('[data-fx-colour]'); if (!sel || !colour) return;
    var opt = [].filter.call(sel.options || [], function (o) { return o.value.toLowerCase() === colour.toLowerCase(); })[0];
    if (opt && sel.value !== opt.value) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: false })); }   // the card's own handler picks Ships Now if that colour is on the shelf, else Made for You
  }
  function shelfFirst(li) {
    var sel = li.querySelector('[data-fx-colour]'), vs = []; try { vs = JSON.parse((li.querySelector('[data-fx-variants]') || {}).textContent || '[]'); } catch (e) {}
    var cur = vs.filter(function (v) { return sel && v.c === sel.value && v.now; })[0], now = vs.filter(function (v) { return v.now; })[0];
    if (sel && !cur && now && sel.value !== now.c) { sel.value = now.c; sel.dispatchEvent(new Event('change', { bubbles: false })); }   // HOTFIX ②: never bubbles into Dawn's cart form (it posted quantity:"<colour>" → 400 → false error banner)
  }
  function smart(part, r, cat, sig) {
    var fx = part.closest('[data-fx]'), H = window.IASHarmony; if (!fx || !H) return;
    var box = fx.querySelector('[data-fx-part="smart"]'), track = box && box.querySelector('[data-fx-strack]'); if (!track) return;
    var attrs = (hmap && hmap.attrs) || {}, items = cartItems(part), inCart = items.map(function (i) { return i.handle; });
    var shown = inCart.concat([].map.call(part.querySelectorAll('[data-fx-card]'), function (c) { return c.dataset.handle; }));
    var hz = (r && r.hz) || (items.map(function (i) { return (/(432|440)/.exec(i.title) || [])[1]; }).filter(Boolean)[0]) || '432';
    var byH = {}; (cat || []).forEach(function (c) { byH[c.handle] = c; });
    var list = [];
    function ok(h) { return h && shown.indexOf(h) < 0 && !list.some(function (x) { return x.h === h; }); }
    function voiceOf(c) { var v = H.voice(c, attrs); return v && c.available && !v.ex && !v.scale && v.hz === hz ? v : null; }
    var sm = shipMath(part);   /* AOV R1: the gap-filler pick is retired — picks = chord partner · smaller sibling · other tuning */
    /* ① chord-completing key: the pick if the chord row lacks it, else another form of that tone */
    if (r && (r.state === 'build' || r.state === 'clash')) {
      (r.need || []).some(function (n) {
        if (!n.pick) return false;
        if (ok(n.pick.handle)) { list.push({ h: n.pick.handle, why: 'The ' + n.role + ' of ' + r.target.name, src: 'drawer-smart' }); return true; }
        var alt = (cat || []).map(function (c) { var v = voiceOf(c); return v && v.pc === n.pick.pc && ok(c.handle) ? { c: c, v: v } : null; }).filter(Boolean)
          .sort(function (a, b) { return Math.abs(a.v.midi - n.pick.midi) - Math.abs(b.v.midi - n.pick.midi) || (b.c.now ? 1 : 0) - (a.c.now ? 1 : 0); })[0];
        if (alt) { list.push({ h: alt.c.handle, why: 'Another ' + n.role + ' for ' + r.target.name, src: 'drawer-smart' }); return true; }
        return false;
      });
    }
    /* ① "Make it a set" — the matching Expansion Pack, position ONE (POLISH ② 10-16; V1 UNLOCKED 10-18, Captain + Mac: V1 print
       files 16/16). EXACT pairings only — same body, same Hz, never cross; no pack for Dorian / Major / Triple / DNA / Single F#4s.
       The pack card takes the flute's colour (Ships Now if that colour's pack is on the shelf, else Made for You). Packs are
       tagged no-ladder, so afford() never prints a Duo/Trio/Ensemble saving on them. */
    var PACK_FOR = {
      'eco-f-4-drone-flute-432-hz': ['f-4-drone-expansion-pack-432-hz-modular-kit-system', 'original F#4', '432'],
      'f-4-drone-flute-440-hz': ['f-4-drone-expansion-pack-440-hz-modular-kit-system', 'original F#4', '440'],
      'f-4-v2-0-drone-flute-432-hz': ['f-4-drone-v2-0-expansion-pack-432-hz-modular-kit-system', 'V2 flute', '432'],
      'f-4-v2-0-drone-flute-440-hz': ['f-4-drone-v2-0-expansion-pack-440-hz-modular-kit-system', 'V2 flute', '440']
    };
    /* AOV R1: smaller sibling + other tuning of the newest key in the bag (custom.smaller_sibling / custom.hz_twin, server map) */
    var rel = {}; try { rel = JSON.parse((fx.querySelector('[data-fx-rel]') || {}).textContent || '{}'); } catch (e) {}
    items.some(function (i) { var r0 = rel[i.handle]; if (r0 && r0.small && ok(r0.small)) { list.push({ h: r0.small, why: 'The smaller version of your key', src: 'drawer-smart' }); return true; } return false; });
    items.some(function (i) { var r0 = rel[i.handle]; if (r0 && r0.twin && ok(r0.twin)) { list.push({ h: r0.twin, why: 'The same key in ' + r0.twinHz + ' Hz', src: 'drawer-smart' }); return true; } return false; });
    items.some(function (i) {
      var pk = PACK_FOR[i.handle]; if (!pk || !ok(pk[0])) return false;
      list.unshift({ h: pk[0], why: 'Expand your drone' + (rates && rates.pack_pair && rates.pack_pair.pct ? ' · ' + rates.pack_pair.pct + '% off with your F#4' : '') + ' · same ' + pk[2] + ' Hz',   /* PACK-PAIRING: offered only for the matching flute in the bag */ src: 'drawer-smart', colour: i.colour, pack: true }); return true;
    });
    list = list.slice(0, list.length && list[0].pack ? 4 : 3);   // pack (F#4) + up to 3 picks
    var sSig = sig + '#' + list.map(function (x) { return x.h; }).join(',');
    if (box.dataset.fxSig === sSig) return;
    box.dataset.fxSig = sSig;
    fx.querySelectorAll('[data-fx-part="more"]').forEach(function (m) { m.hidden = true; });   // the engine row replaces the fallback
    Promise.all(list.map(function (x) { return cardFor(x.h); })).then(function (htmls) {
      if (box.dataset.fxSig !== sSig) return;
      track.innerHTML = '';
      htmls.forEach(function (html, i) {
        if (!html) return;
        var tmp = document.createElement('ul'); tmp.innerHTML = html; var li = tmp.firstElementChild, x = list[i];
        if (x.gap && !(sm && sm.proj(cardPrice(li)) >= sm.T)) return;              // honesty: the rendered price must still cross
        li.setAttribute('data-ias-src', x.src);
        var why = li.querySelector('[data-fx-why]'); if (why) { why.dataset.fxSet = '1'; afford(li, x.why); }
        track.appendChild(li);
        if (x.pack) { packColour(li, x.colour); return; }                         // the set: same colour as the flute, not "first on the shelf"
        shelfFirst(li);
      });
      box.hidden = !track.children.length;
      var fxe = box.closest('[data-fx]'); if (fxe && (hmap || rates)) setTimeout(function () { chipCards(fxe); }, 0);   // ROUND 3 FIX: same as the chord row
    });
  }

  /* the same product never shows twice: a note the engine placed leaves "You may also like" */
  function hideDupes(part) {
    var fx = part.closest('[data-fx]'); if (!fx) return;
    var placed = [].map.call(part.querySelectorAll('[data-fx-card]'), function (c) { return c.dataset.handle; });
    fx.querySelectorAll('[data-fx-part="more"] [data-fx-card]').forEach(function (c) { c.hidden = placed.indexOf(c.dataset.handle) >= 0; });
  }

  function arrows(fx) {
    var t = fx.querySelector('[data-fx-track]'), p = fx.querySelector('[data-fx-prev]'), n = fx.querySelector('[data-fx-next]');
    if (!t || !p) return;
    var sync = function () {
      p.disabled = t.scrollLeft <= 2;
      n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      fx.classList.toggle('fx--static', p.disabled && n.disabled);
    };
    var step = function (d) { var c = t.querySelector('[data-fx-card]'); t.scrollBy({ left: d * ((c ? c.offsetWidth : 200) + 10), behavior: reduce ? 'auto' : 'smooth' }); };
    p.onclick = function () { step(-1); }; n.onclick = function () { step(1); };
    t.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function initFx(fx) {
    if (fx.dataset.fxReady) return;
    fx.dataset.fxReady = '1';
    fx.querySelectorAll('[data-fx-part]').forEach(arrows);
    chipCards(fx);
  }

  /* colour switch — same dual-supply order as the server pick; button, badge, price, photo all follow */
  /* FINAL POLISH: CAPTURE phase + stopPropagation — a card's colour select lives inside Dawn's cart <form>; a bubbling change reached
     Dawn's CartItems.onChange → updateQuantity(undefined, "Black") → "There was an error while updating your cart". The card
     still re-picks here; Dawn never sees a colour change as a quantity change. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-fx-colour]'); if (!sel) return;
    e.stopPropagation();
    var card = sel.closest('[data-fx-card]'), vs;
    try { vs = JSON.parse(card.querySelector('[data-fx-variants]').textContent); } catch (x) { return; }
    var c = sel.value;
    var pick = vs.find(function (v) { return v.c === c && v.now; }) || vs.find(function (v) { return v.c === c; }); if (!pick) return;
    var btn = card.querySelector('[data-shy-add]'); if (btn.classList.contains('is-in')) return;
    btn.dataset.shyAdd = pick.id;
    var b = card.querySelector('[data-fx-badge]');
    b.textContent = pick.now ? 'Ships Now' : 'Made for You · 2–3 wks';
    b.dataset.fxTip = pick.now ? 'On our shelf — ships in 1–3 business days' : 'Printed to order for you — ships in 2–3 weeks';
    b.classList.toggle('shy-badge--now', pick.now); b.classList.toggle('shy-badge--mfy', !pick.now);
    card.querySelector('[data-fx-price]').textContent = pick.pm;
    var cp = card.querySelector('[data-fx-cp]'); cp.textContent = pick.cm || ''; cp.hidden = !pick.cm;
    var img = card.querySelector('[data-fx-img]'); if (img && pick.img) img.src = pick.img;
    if (card.querySelector('[data-fx-why][data-fx-reason]')) afford(card.closest('li') || card);   // DECK ③: price/save follow the colour
  }, true);

  /* ───────── ② REWARDS ───────── */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'fx-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  function confetti(from) {
    if (reduce) return;
    var cv = document.createElement('canvas'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.className = 'fx-confetti'; cv.width = innerWidth * dpr; cv.height = innerHeight * dpr;
    document.body.appendChild(cv);
    var g = cv.getContext('2d'); g.scale(dpr, dpr);
    var r = from ? from.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 3, width: 0 };
    var cols = ['#ff4878', '#ffaa3c', '#fae650', '#50dc8c', '#46aaff', '#9664ff'], ps = [];
    for (var i = 0; i < 110; i++) ps.push({ x: r.left + Math.random() * (r.width || 60), y: r.top, vx: (Math.random() - .5) * 9, vy: -Math.random() * 9 - 3, s: 4 + Math.random() * 5, a: Math.random() * 6, c: cols[i % 6] });
    var t0 = performance.now();
    (function frame(t) {
      var k = (t - t0) / 1400; g.clearRect(0, 0, innerWidth, innerHeight);
      ps.forEach(function (p) { p.vy += .32; p.x += p.vx; p.y += p.vy; p.a += .15; g.save(); g.globalAlpha = Math.max(0, 1 - k); g.translate(p.x, p.y); g.rotate(p.a); g.fillStyle = p.c; g.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2); g.restore(); });
      if (k < 1) requestAnimationFrame(frame); else cv.remove();
    })(t0);
  }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function rewards(consume) {
    var lad = document.querySelector('cart-drawer.active [data-shy-ladder], #MainContent [data-shy-ladder]') || document.querySelector('[data-shy-ladder]');
    if (!lad || !rates) return;
    var keys = +lad.dataset.keys || 0, total = +lad.dataset.total || 0, T = Math.round((rates.free_ship_threshold || 0) * 100);
    var t = tierFor(keys), free = (lad.dataset.currency || 'USD') === 'USD' && T && total >= T;
    var state = (t ? t.min_keys : 0) + '|' + (free ? 1 : 0), prev = ss('fx-state');
    ss('fx-state', state);
    var pending = consume && ss('fx-added'); if (pending) { ss('fx-added', null); toast('Added ' + pending + ' ✓'); }
    if (prev == null || prev === state) return;
    var pt = +prev.split('|')[0], pf = prev.split('|')[1] === '1';
    if (t && t.min_keys > pt) { confetti(lad); toast('🎉 ' + t.name.replace(/\s*·.*$/, '') + ' — ' + t.pct + '% off is on'); }
    else if (free && !pf) { confetti(lad); toast('🚚 Free US shipping unlocked'); }
  }
  /* remember what was just added (survives the /cart page reload) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-shy-add]'); if (!b || b.disabled) return;
    var card = b.closest('[data-fx-card], [data-shy-card]');
    var n = card && (card.dataset.title || (card.querySelector('.shy-card__name') || {}).textContent);
    if (n) ss('fx-added', n.trim());
  }, true);

  /* ───────── ③ TOOLTIPS ───────── */
  var tip = null;
  function showTip(el) {
    var txt = el.dataset.fxTip; if (!txt) return;
    if (!tip) { tip = document.createElement('div'); tip.className = 'fx-tip'; tip.setAttribute('role', 'tooltip'); document.body.appendChild(tip); }
    tip.textContent = txt; tip.classList.add('is-on');
    var r = el.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    var x = Math.max(8, Math.min(innerWidth - w - 8, r.left + r.width / 2 - w / 2)), y = r.top - h - 8;
    if (y < 8) y = r.bottom + 8;
    tip.style.left = x + 'px'; tip.style.top = y + 'px';
  }
  function hideTip() { if (tip) tip.classList.remove('is-on'); }
  document.addEventListener('mouseover', function (e) { var el = e.target.closest && e.target.closest('[data-fx-tip]'); if (el) showTip(el); });
  document.addEventListener('mouseout', function (e) { if (e.target.closest && e.target.closest('[data-fx-tip]')) hideTip(); });
  document.addEventListener('focusin', function (e) { var el = e.target.closest && e.target.closest('[data-fx-tip]'); if (el) showTip(el); else hideTip(); });
  document.addEventListener('scroll', hideTip, true);
  /* phones: a tap explains too */
  var tipT = null;
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-fx-tip]'); if (!el) return;
    showTip(el); clearTimeout(tipT); tipT = setTimeout(hideTip, 2600);
  });
  function tipLadders() {
    var ts = tiers();
    document.querySelectorAll('[data-shy-ladder] .shy-ladder__seg').forEach(function (s, i, all) {
      var idx = [].indexOf.call(s.parentNode.children, s);
      var t = idx > 0 ? ts[idx - 1] : null;
      var tipTxt = t ? t.name : 'Your first key';
      if (s.dataset.fxTip !== tipTxt) { s.dataset.fxTip = tipTxt; s.tabIndex = 0; }
    });
  }

  /* ───────── ④ Z-INDEX LAW sentinel ───────── */
  /* buy buttons — a popup over any of these is closed (they are what the shopper came for) */
  var PROTECT_FLOW = 'product-form .product-form__submit, .product-form__buttons .shopify-payment-button, #checkout, .cart__dynamic-checkout-buttons, [data-shy-add]:not(.is-in)';
  /* DIAL-IN 10-16 site-wide law: no floater over ATC, swatches, the chord section, the ▶ sampler, the sticky bar or a product grid */
  var PROTECT_ZONE = PROTECT_FLOW + ', variant-selects, variant-radios, .ias-sample-key, .product__info-container .shy, .product__info-container .ias-icc,' +
    ' [data-fx], .fx-capture, .product-grid .grid__item, ul.grid .card-wrapper, .collection .card-wrapper, .icb-foot.live, #ias-chord-builder:not([hidden]) .icb__roots, #ias-chord-builder .icb__panel:not([hidden]), .ics, [data-ipc]:not([hidden])';
  var PROTECT_TOP = '.ias-satc.on, .ias-stackbar.on, .ipc-lb:not([hidden]) .ipc-lb__panel, cart-drawer.active .drawer__footer, cart-drawer.active .cart__ctas';
  var userOpened = 0;
  /* a tap on the Klaviyo TEASER = the shopper asked for the popup; taps inside the popup (close, no thanks) don't count */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.needsclick, [class*="kl-teaser"]') && !e.target.closest('[role="dialog"]')) userOpened = Date.now();
  }, true);
  function vis(el) { if (!el || !el.getClientRects().length) return null; var r = el.getBoundingClientRect(); if (r.width < 2 || r.height < 2 || r.bottom < 0 || r.top > innerHeight) return null; var s = getComputedStyle(el); return (s.visibility === 'hidden' || s.display === 'none') ? null : r; }
  function hit(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
  function protectedRects(sel) { var out = []; document.querySelectorAll(sel).forEach(function (el) { var r = vis(el); if (r) out.push(r); }); return out; }
  /* Shopify chat nests its launcher two shadow roots deep (shopify-chat → shopify-agent-runtime) */
  function deepFind(host, sel) {
    var root = host.shadowRoot; if (!root) return null;
    var hit = root.querySelector(sel); if (hit) return hit;
    var kids = root.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) { if (kids[i].shadowRoot) { var h = deepFind(kids[i], sel); if (h) return h; } }
    return null;
  }
  function floaters() {
    var out = [];
    /* Klaviyo onsite forms: top-level fixed .needsclick containers (teaser + popup) */
    document.querySelectorAll('body > div .needsclick, body > .needsclick').forEach(function (el) {
      if (getComputedStyle(el).position !== 'fixed') return;
      var p = el.parentElement; while (p && p !== document.body) { if (getComputedStyle(p).position === 'fixed') return; p = p.parentElement; }
      var dlg = el.matches('[role="dialog"]') ? el : el.querySelector('[role="dialog"]');
      var box = dlg && (dlg.querySelector('[data-testid="POPUP"], [data-testid="FLYOUT"]') || dlg);
      out.push({ host: el, box: box || el, kind: dlg && /POPUP/i.test(dlg.getAttribute('aria-label') || '') ? 'popup' : 'teaser' });
    });
    var chat = document.querySelector('shopify-chat');
    if (chat) { var act = deepFind(chat, 'button.activator, [part~="activator"]'); if (act) out.push({ host: chat, box: act, kind: 'hide' }); }
    var g = document.getElementById('google-merchantwidget-iframe-wrapper'); if (g) out.push({ host: g, box: g, kind: 'hide' });
    document.querySelectorAll('[id*="gorgias" i]').forEach(function (el) { if (getComputedStyle(el).position === 'fixed') out.push({ host: el, box: el, kind: 'hide' }); });
    return out;
  }
  var lawLog = [];
  function law() {
    var flow = protectedRects(PROTECT_FLOW), top = protectedRects(PROTECT_TOP), all = protectedRects(PROTECT_ZONE).concat(top);
    var quietZone = klQuietZone();
    floaters().forEach(function (f) {
      var host = f.host;
      if (f.kind === 'popup') {
        /* the popup's dim layer covers the whole page: if a buy button is on screen and the shopper didn't open it, close it */
        /* /cart hides Klaviyo by CSS from first paint, so judge "open" by geometry, not visibility */
        var br = f.box.getBoundingClientRect();
        if (quietZone ? !(br.width > 0 && br.height > 0) : !vis(f.box)) {
          delete host.dataset.fxUser; delete host.dataset.fxClosed; document.documentElement.classList.remove('fx-kl-allow'); return;
        }
        if (host.dataset.fxUser) return;
        if (Date.now() - userOpened < 4000) { host.dataset.fxUser = '1'; return; }
        /* /cart is pure checkout intent: the welcome popup never auto-opens there, whatever is on screen */
        if ((flow.length || quietZone) && !host.dataset.fxClosed) {
          var x = host.querySelector('button[aria-label*="lose" i], .klaviyo-close-form');
          if (x) { host.dataset.fxClosed = '1'; x.click(); lawLog.push('popup-closed'); }
        }
        return;
      }
      var lift = +host.dataset.fxLift || 0;
      var r = f.box.getBoundingClientRect();
      var base = { left: r.left, right: r.right, top: r.top + lift, bottom: r.bottom + lift };
      var block = all.filter(function (p) { return hit(base, p); });
      if (!block.length) {
        if (lift) { host.style.transform = ''; host.dataset.fxLift = 0; }
        if (host.classList.contains('fx-behind') && Date.now() - (+host.dataset.fxSeen || 0) < 1200) return;
        host.classList.remove('fx-behind');
        return;
      }
      host.dataset.fxSeen = Date.now();
      if (f.kind === 'teaser') {
        var need = Math.max.apply(null, block.map(function (p) { return base.bottom - p.top + 10; }));
        if (need > 0 && base.top - need > innerHeight * 0.25) {
          if (need !== lift) { host.style.transform = 'translateY(' + (-need) + 'px)'; host.dataset.fxLift = need; lawLog.push('teaser-lift'); }
          host.classList.remove('fx-behind');
          return;
        }
      }
      if (!host.classList.contains('fx-behind')) { host.classList.add('fx-behind'); lawLog.push('behind:' + (host.id || host.tagName)); }
    });
  }
  window.__iasLaw = { run: law, log: lawLog };
  /* Klaviyo "quiet zones": product pages + /cart — no floating form there (Deck 10-16); the inline line below the chord section
     opens it on request instead */
  function klQuietZone() { return /^\/cart\/?$/.test(location.pathname) || !!document.querySelector('[id^="MainProduct-"], [data-ics-card], [data-icb-chord], [data-ikf-add]'); }  // REPAIR 1: + chord pages
  function capture() {
    var main = document.querySelector('[id^="MainProduct-"]');
    var ipc = main && main.querySelector('[data-ipc]:not([hidden])'), have = document.querySelector('.fx-capture');
    /* the line always sits directly under the chord section (Play your chord un-hides after boot → re-anchor) */
    if (have && ipc && have.previousElementSibling !== ipc) { ipc.parentNode.insertBefore(have, ipc.nextSibling); return; }
    if (!main || have) return;
    var host = main.querySelector('[data-ipc]:not([hidden]), .product__info-container .shy, .product__info-container .ias-icc') ||
      main.querySelector('.product__info-container .ias-sample-key') || main.querySelector('.product__info-container product-form');
    if (!host) return;
    var p = document.createElement('p'); p.className = 'fx-capture';
    p.innerHTML = '<button type="button" data-fx-capture>Not ready yet? Get 10% off your first key <span aria-hidden="true">→</span></button>';
    host.parentNode.insertBefore(p, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('[data-fx-capture]'))) return;
    userOpened = Date.now(); document.documentElement.classList.add('fx-kl-allow');
    (window._klOnsite = window._klOnsite || []).push(['openForm', 'RKZ6rL']);
  });
  var lawRaf = 0;
  /* a timer, not rAF: the law must hold even when frames are paused (background tab, embedded webviews) */
  function lawSoon() { if (!lawRaf) lawRaf = setTimeout(function () { lawRaf = 0; law(); }, 60); }
  addEventListener('scroll', lawSoon, { passive: true });
  addEventListener('resize', lawSoon);
  var beats = 0, beat = setInterval(function () { law(); if (++beats > 60) clearInterval(beat); }, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) lawSoon(); });

  /* ───────── wiring ───────── */
  /* /cart page: Dawn re-renders the totals but not the Check out button — keep its "· $X" equal to the estimated total */
  function syncCheckout() {
    document.querySelectorAll('[data-fx-co-amt]').forEach(function (a) {
      var l = scope(a).querySelector('[data-shy-ladder]'); if (!l || (l.dataset.currency || 'USD') !== 'USD') return;
      var tc = +l.dataset.total || 0, t = '$' + (tc / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (a.textContent !== t) a.textContent = t;
      /* CART FIX (10-21): the price is part of the button's ONE accessible name ("Checkout · $251.25"), and a cart that fills on /cart
         unhides the amount + enables the button */
      var w = a.closest('.fx-co__amt'), btn = a.closest('button');
      if (w) w.hidden = !(tc > 0);
      if (btn) { if (tc > 0) { btn.setAttribute('aria-label', 'Checkout · ' + t); btn.disabled = false; } else btn.removeAttribute('aria-label'); }
    });
  }
  function sweep(consume) {
    syncCheckout();
    capture();
    document.querySelectorAll('[data-fx-harmony]').forEach(harmony);
    document.querySelectorAll('[data-fx]').forEach(function (fx) { initFx(fx); if (hmap || rates) chipCards(fx); });
    tipLadders();
    rewards(consume === true);
    lawSoon();
  }
  var mt = null;
  new MutationObserver(function (muts) {
    if (!muts.some(function (m) { var n = m.target; return !(n.closest && n.closest('.fx-toast, .fx-tip, [data-fx-track]')); })) return;
    clearTimeout(mt); mt = setTimeout(function () { sweep(false); }, 140);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-keys', 'data-total'] });
  document.addEventListener('cart:updated', function () { setTimeout(function () { sweep(true); }, 200); });
  try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { sweep(true); }, 250); }); } catch (e) {}

  function boot() {
    Promise.all([getJSON(RATES), getJSON(MAP)]).then(function (r) { rates = r[0]; hmap = r[1]; sweep(true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
